import { useMemo } from "react";
import { zxcvbn } from "@zxcvbn-ts/core";
import { cn } from "../../lib/utils";

export function PassphraseStrength({ passphrase }: { passphrase: string }) {
  const result = useMemo(
    () => (passphrase.length > 0 ? zxcvbn(passphrase) : null),
    [passphrase],
  );
  const score = result?.score ?? 0;
  const guessesLog10 = result?.guessesLog10 ?? 0;
  return (
    <>
      <div className="mt-2 flex gap-1">
        {[0, 1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className={cn(
              "h-1 flex-1 rounded-full",
              i < score ? "bg-ok" : "bg-border",
            )}
          />
        ))}
      </div>
      <div className="mt-1.5 flex justify-between text-[11px] text-text-soft">
        <span>
          {score >= 4
            ? "very strong"
            : score >= 3
              ? "strong"
              : score >= 2
                ? "ok"
                : "too weak"}
        </span>
        <span className="font-mono">
          {Math.round(guessesLog10 * 3.32)} bits
        </span>
      </div>
    </>
  );
}
